(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = document.getElementById(root.dataset.formId);
    const monitor = root.querySelector('[data-nr-sim-monitor]');
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:root.dataset.currency,minimumFractionDigits:0,maximumFractionDigits:2});
    const desktopPrice = root.querySelector('.product-sticky-form__price');
    const bayOnlyPrice = desktopPrice?.innerHTML;
    const turfOptions = [...root.querySelectorAll('[data-nr-bay-turf-option]')];
    const selectedTurf = () => turfOptions.find(option => option.checked && option.value);
    function update() {
      const selected = monitor?.selectedOptions[0];
      const turf = selectedTurf();
      const hasAddOn = !!(selected?.value || turf);
      const total = Number(root.dataset.price) + Number(selected?.dataset.price || 0) + Number(turf?.dataset.price || 0);
      const mainPrice = root.querySelector('[data-bay-button-price]');
      if (mainPrice) mainPrice.textContent = money.format(total / 100);
      const totalLabel = root.querySelector('[data-bay-total]'); if (totalLabel) totalLabel.textContent = money.format(total / 100);
      const totalRow = root.querySelector('[data-bay-total-row]'); if (totalRow) totalRow.hidden = !hasAddOn;
      const link = root.querySelector('[data-bay-monitor-link]');
      if (link) { link.hidden = !selected?.value; if (selected?.value) link.href = selected.dataset.url; }
      const turfNote = root.querySelector('[data-nr-bay-turf-note]');
      if (turfNote) { turfNote.textContent = turf?.dataset.note || ''; turfNote.hidden = !turf?.dataset.note; }
      const turfLink = root.querySelector('[data-nr-bay-turf-link]');
      if (turfLink) { turfLink.hidden = !turf; if (turf) turfLink.href = turf.dataset.url; }
      const sticky = root.querySelector('[data-sticky-button-sale-price]');
      if (sticky) sticky.textContent = '· ' + money.format(total / 100);
      if (desktopPrice) {
        if (hasAddOn) desktopPrice.textContent = money.format(total / 100) + ' ' + (root.dataset.addonsSuffix || '');
        else desktopPrice.innerHTML = bayOnlyPrice;
      }
    }
    if (monitor) { monitor.disabled = false; monitor.addEventListener('change', update); }
    turfOptions.forEach(option => option.addEventListener('change', update));
    // The theme's product-form submit (nrab-theme.js) adds every item this returns in one /cart/add request.
    // Returning null keeps its default path: bay alone, or bay + monitor.
    if (form && turfOptions.length) form.nrSetupItems = () => {
      const turf = selectedTurf();
      if (!turf) return null;
      const data = new FormData(form);
      const items = [{ id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1) }];
      const monitorOption = monitor?.selectedOptions[0];
      if (monitorOption?.value && !monitorOption.disabled) items.push({ id: Number(monitorOption.value), quantity: 1 });
      items.push({ id: Number(turf.value), quantity: 1 });
      return items;
    };
    if (root.querySelector('[data-bay-button-price]')) update();
    form?.addEventListener('cart-notification:show', event => {
      const status = root.querySelector('[data-bay-status]');
      status.textContent = event.detail.status === 'error' ? event.detail.error : '';
    });
    const rail = root.querySelector('[data-bay-gallery]');
    const previous = root.querySelector('[data-bay-prev]');
    const next = root.querySelector('[data-bay-next]');
    const count = rail.children.length;
    const thumbs = [...root.querySelectorAll('[data-bay-thumb]')];
    const position = () => Math.round(rail.scrollLeft / rail.clientWidth);
    function sync() { const index = position(); previous.disabled = index <= 0; next.disabled = index >= count - 1; root.querySelector('[data-bay-position]').textContent = `${index + 1} / ${count}`; thumbs.forEach((thumb,i)=>{if(i===index) thumb.setAttribute('aria-current','true'); else thumb.removeAttribute('aria-current');}); }
    function move(direction) { rail.scrollTo({left:Math.max(0,Math.min(count-1,position()+direction))*rail.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}); }
    thumbs.forEach((thumb,index)=>thumb.addEventListener('click',event=>{event.preventDefault();move(index-position());}));
    previous.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
    rail.addEventListener('scroll',sync,{passive:true});rail.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});sync();
  }
  document.querySelectorAll('[data-nr-bay]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-nr-bay]').forEach(init));
})();
